import type {AddLeadContactFormPayload} from "./add-lead-contact.schema";

import {addLeadContact} from "@project/sdk/sales";
import {AddLeadContactBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../../../lead-keys";

import {addLeadContactMapper} from "./add-lead-contact.mapper";

export function addLeadContactMutationOptions(leadId: string) {
  return mutationOptions({
    mutationKey: leadMutationKeys.addLeadContact,
    mutationFn: (formPayload: AddLeadContactFormPayload) => {
      const request = AddLeadContactBody.parse(addLeadContactMapper.toSdk(formPayload));

      return addLeadContact(leadId, request);
    },
    onSuccess: async (_contactId, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.detail(leadId)});
    },
  });
}
